// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const backText = "SidebarBackButton__backText__TWpaJ";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const iconWrapper = "SidebarBackButton__iconWrapper__qOqQX";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const sidebarBackButton = "SidebarBackButton__sidebarBackButton__ZcR+h";